import { render, staticRenderFns } from "./relatedFullStage.vue?vue&type=template&id=3e623eea&scoped=true"
import script from "./relatedFullStage.vue?vue&type=script&lang=ts"
export * from "./relatedFullStage.vue?vue&type=script&lang=ts"
import style0 from "./relatedFullStage.vue?vue&type=style&index=0&id=3e623eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e623eea",
  null
  
)

export default component.exports